import { Directive, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ElasticSearchService } from './search-elasticsearch.service';
import { ContentService } from './content.service';
import { SearchService } from './search.service';
import { UtilsService } from './utils.service';
import { LoadingPage } from './loading-indicator';

import { isBrowser, isNode } from 'angular2-universal';

import { prebootComplete } from "angular2-universal";


@Directive({
  selector: '[searchable-contents]',
  exportAs: 'sc',
})
export class SearchableContentsComponent extends LoadingPage implements OnInit {

  @Input() context;
  @Input() pageSize;
  @Input() active;
  @Input() noCache: boolean = false;

  // "loading" available in super class
  public esQuery: Object;
  public esContents: Object;
  public dbContents: Object[];
  public esAggregations: Object;
  public esFilters: Object[] = [];

  public entryType;
  public entryField;
  public hasActiveParam;

  public aggFields = {
    record: ['type','soloist','composer','conductor','instrument'],
    writing: ['language','tag','author'],
  }

  constructor(private contentService: ContentService, private searchService: SearchService, private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) {
    super(true); // sets loading to true
  }

  ngOnInit() {

    // FRONT: Initial entry into a catalogue type with nice urls
    this.route.params.subscribe(params => {
      // Entry 
      if( params['type']!=null || params['field']!=null){
        // Entry field (e.g composer/mozart)
        if(params['field']!=null && params['value']!=null) {
          this.entryField = params['field'];
          let filter = JSON.parse('{"'+this.entryField+'": "'+params['value']+'"}');
          this.esFilters = this.utils.filtersToEsFilters([filter], '.raw');
        } else 
        // Entry type
        if(params['type']!=null) {
          this.entryType = params['type'];
          this.esFilters = this.utils.filtersToEsFilters([{type: this.entryType}], '.raw');
        }
        if(this.active)
          this.es.addFilterActive(this.esFilters, this.active);
        this.es.setFilterQueryString(this.esFilters);
        this.es.setAggregationQueryString(this.aggFields[this.context]);
        this.esQuery = this.es.searchQuery;
        this.search();
      // }
      // // Entry field (e.g composer/mozart)
      // if(params['field']!=null && params['value']!=null) {
      //   let filter = JSON.parse('{"'+params['field']+'": "'+params['value']+'"}');
      //   console.log(filter);
      //   this.esFilters = this.utils.filtersToEsFilters([filter], '.raw');
      //   if(this.active)
      //     this.es.addFilterActive(this.esFilters, this.active);
      //   this.es.setFilterQueryString(this.esFilters);
      //   this.esQuery = this.es.searchQuery;
      //   this.search();
      // } else
      // // Entry type
      // if(params['type']!=null) {
      //   this.entryType = params['type'];
      //   this.esFilters = this.utils.filtersToEsFilters([{type: this.entryType}], '.raw');
      //   if(this.active)
      //     this.es.addFilterActive(this.esFilters, this.active);
      //   this.es.setFilterQueryString(this.esFilters);
      //   this.esQuery = this.es.searchQuery;
      //   this.search();
      } else 
      // ADMIN: Active/non-active items
      if(params['active']!=null) {
        this.hasActiveParam = true;
        let activeSelect: boolean = JSON.parse(params['active']);
        this.esFilters = [];
        this.es.addFilterActive(this.esFilters, activeSelect);
        this.es.setFilterQueryString(this.esFilters);
        this.esQuery = this.es.searchQuery;
        this.search();
      }
    });

    // Further filtering with query params
    this.route.queryParams.subscribe(params => {

      if(!this.entryType && !this.hasActiveParam){

        // Aggregations
        this.es.setAggregationQueryString(this.aggFields[this.context]);

        if(!this.entryField) {

          // Search
          if (params['s'] != null) {
            let searchFields = {
              record: ['title', 'music_piece_title', 'instrument', 'orchestra', 'composer', 'conductor', 'soloist'],
              writing: ['title','content','author'],
            }
            this.es.setSearchQueryString(searchFields[this.context], params['s']);
          }

          // Filters
          let filters = this.utils.queryParamsParser(params, 'f');
          this.esFilters = this.utils.filtersToEsFilters(filters, '.raw');
          this.es.setFilterQueryString(this.esFilters);

          }
        
      }

      // Clear search
      if (params['s'] == null)
        this.es.clearSearchQueryString();

      // Pagination
      if (params['from'] != null)
        this.es.setPaginationQueryString(params['from'], this.pageSize);
      else // clear
        this.es.setPaginationQueryString(null, this.pageSize);

      // Active
      if(this.active)
        this.es.addFilterActive(this.esFilters, this.active);

      // Run search
      this.esQuery = this.es.searchQuery;

      this.standby(); // loading
      this.search();
      

    });

  }

  search() {
    // Retrieve IDs from index
    //console.log(this.es.searchQuery);
    this.searchService.search(this.context, this.es.searchQuery)
      .then(response => {
        let indexData = JSON.parse(response.body);
        this.esContents = indexData.hits;
        this.esAggregations = indexData.aggregations;
        // Retrieve info from db based on index ids
        this.dbContents = [];
        let ids: any = [];
        for (let hit of this.esContents['hits'])
          ids.push(hit._id);
        if (ids.length > 0) {
          let idsString = ids.join(',');
          this.contentService.findContents(this.context, idsString, this.noCache)
            .then(res => {
              this.dbContents = res;
              this.ready(); // sets loading to false and preboot complete
            });
        } else 
          this.ready();
      });
  }

  dbContentsLimited(limit: number): any[] {
    let limited = [];
    for (var i = 0; i < this.dbContents.length; i++) {
      limited.push(this.dbContents[i]);
      if (i == limit - 1)
        break;
    }
    return limited;
  }

  searchCallBack(info: any) {
    //console.log('[search]', info);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/searchable-contents.component.ts